import { render, staticRenderFns } from "./EditJurisdiction.vue?vue&type=template&id=65b23831&scoped=true"
import script from "./EditJurisdiction.vue?vue&type=script&lang=js"
export * from "./EditJurisdiction.vue?vue&type=script&lang=js"
import style0 from "./EditJurisdiction.vue?vue&type=style&index=0&id=65b23831&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b23831",
  null
  
)

export default component.exports